import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 043
        'numConvocatoria' : 'Convocatoria No. 043/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N148-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación del CAPASITS Pachuca.; ubicada en la localidad de , Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N148/N148.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N147-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación y rehabilitación del CAIA Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N147/N147.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N146-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de acceso a la Av. Benito Juárez, localidad San Juan Tilcuautla, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N146/N146.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N145-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Encauzamiento y saneamiento del río Chinguiñoso, en el municipio de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo (Segundo procedimiento)',
        'urlAnexos' : `${ ligasipdus }43/N145/N145.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N144-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de colector pluvial tierra y libertad, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N144/N144.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N143-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Terminación de pavimentación de concreto hidráulico en calle 24 de octubre, San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N143/N143.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 042
        'numConvocatoria' : 'Convocatoria No. 042/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N142-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del encauzamiento Río de las Avenidas (muro izquierdo y plantilla), tramo: Carr. antigua La Paz - avenida Moreda.; ubicada en la localidad de La Noria, Municipio de Mineral de la Reforma, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N142/N142.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N141-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del encauzamiento Río de las Avenidas (muro izquierdo y derecho), tramo: carr. antigua La Paz - avenida Moreda - fraccionamiento los Tuzos.; ubicada en la localidad de Los Tuzos, Municipio de Mineral de la Reforma, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N141/N141.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N140-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del paso superior vehicular sobre la C.F. México - Pachuca Km 70+220.; ubicada en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N140/N140.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 041
        'numConvocatoria' : 'Convocatoria No. 041/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N139-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Av. Hombres Ilustres barrio Mexiquito, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo (segundo procedimiento).',
        'urlAnexos' : `${ ligasipdus }41/N139/N139.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N138-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de Boulevard E.C. Tolcayuca - Villa de Tezontepec, tramo Arco Norte - polo de desarrollo; ubicada en Varias localidades, de Cobertura Estatal.',
        'urlAnexos' : `${ ligasipdus }41/N138/N138.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },

    {
        // CONVOCATORIA NUM# 040
        'numConvocatoria' : 'Convocatoria No. 040/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N137-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción Edificio 4, Complejo Hidalgo Honesto; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N137/N137.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N136-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de áreas comerciales en Sector Primario; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N136/N136.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N135-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de cancha San Francisco, en el municipio de Mineral del Monte.; ubicada en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N135/N135.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N134-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de la C.E. Cuautepec - Tulancingo (tercera etapa), en el municipio de Cuautepec de Hinojosa.; ubicada en la localidad de Cuautepec, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N134/N134.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N133-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica de la C.E. Saucillo - Nopala (cuarta etapa), en el municipio de Nopala de Villagrán.; ubicada en la localidad y Municipio de Nopala de Villagrán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N133/N133.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N132-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de la calle Profesor Antonio Chávez Ibarra, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N132/N132.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N131-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de camino Xilitla - Texopich, segunda etapa, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Acoyotla, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N131/N131.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N130-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación de la lateral de servicios del Blvd. Luis D. Colosio, tramo: Blvd. Nuevo Hidalgo al Blvd. Felipe Ángeles, frente al Centro SICT Hidalgo, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N130/N130.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 039
        'numConvocatoria' : 'Convocatoria No. 039/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N129-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Adecuación Integral de las Instalaciones en la Escuela de Música; de Cobertura Estatal',
        'urlAnexos' : `${ ligasipdus }39/N129/N129.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N128-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en la localidad El Jiadi, El Palomo, en la calle Prolongación Álvaro Obregón y División del Sur, en el municipio de El Arenal.; ubicada en la localidad de El Jiadi, Municipio de El Arenal, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N128/N128.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N127-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación de concreto hidráulico en El Arenal en varias calles, en el municipio de El Arenal.; ubicada en la localidad y Municipio de El Arenal, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N127/N127.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N126-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación de Red de Distribución en las Colonias 20 de noviembre, Santa Bárbara y La Isleta, en el municipio de Tepeapulco.; ubicada en Varias localidades del Municipio de Tepeapulco, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N126/N126.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N125-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la lateral de servicios y sobre puente del Blvd. Luis D. Colosio frente a Plaza del Valle, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N125/N125.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N124-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de Alumbrado sobre Áreas Peatonales en el Perímetro de la Glorieta 24 Horas, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N124/N124.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N123-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación del acceso principal Almoloya, en el municipio de Almoloya.; ubicada en la localidad y Municipio de Almoloya, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N123/N123.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N122-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la C.E. Metepec - Tortugas - Acocul, segunda etapa, en el municipio de Metepec.; ubicada en la localidad de Tortugas, Municipio de Metepec, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N122/N122.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N121-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica del paso principal por la localidad de Benito Juárez, en el municipio de Mineral del Chico.; ubicada en la localidad de Benito Juárez, Municipio de Mineral del Chico, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N121/N121.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N120-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación y rehabilitación del tramo carretero Tlanalapa - Cd. Sahagún, acceso principal, (segunda etapa) en el municipio de Tlanalapa.; ubicada en la localidad y Municipio de Tlanalapa, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N120/N120.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N119-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica en tramo Las Conchas - Santa Rosalía, en el municipio de Omitlán de Juárez.; ubicada en la localidad de San Antonio el Paso, Municipio de Omitlán de Juárez, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N119/N119.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N118-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Repavimentación del boulevard acceso a Epazoyucan, E.C.F. Pachuca - Tulancingo, en el municipio de Epazoyucan.; ubicada en la localidad y Municipio de Epazoyucan, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N118/N118.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N117-2026.',
        'vigencia' : '31 de agosto a 11 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Pavimentación de Concreto Hidráulico en calle Caoba y calle Bambú, localidad de Barrio El Judío, en el municipio de Pachuca de Soto.; ubicada en la localidad de Barrio el Judío, Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }39/N117/N117.rar`,
        'start' : '2026-08-31',
        'end' : '2026-09-11',
        'procedimiento' : 'Licitación Pública',
    },
]